import React, { useState, useEffect } from "react";

import slide1 from "./images/slide-1.png";
import slide2 from "./images/slide-2.png";
import slide3 from "./images/slide-3.png";

function Slideshow() {
  const slides = [
    {
      image: slide1,
      title: "Your Trusted Source for Mining, Laboratory & Security Solutions",
      subtitle:
        "Prosep Services Ltd supplies world-class equipment and systems for industrial safety, mineral exploration, and scientific research across Ghana and West Africa.",
      button: "Learn More",
      link: "/about",
    },
    {
      image: slide2,
      title: "We Have International Partners",
      subtitle:
        "Working with global leaders to bring you the best equipment and systems available.",
      button: "Our Partners",
      link: "/about",
    },
    {
      image: slide3,
      title: "Ready to Make an Enquiry?",
      subtitle:
        "Reach out to us with your needs, and we will respond to you as quickly as possible.",
      button: "Contact Us",
      link: "/contact",
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const goTo = (index) => setCurrent(index);
  const next = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prev = () =>
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <>
      <div className="slideshow">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === current ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="slide-overlay">
              <div className="slide-content">
                <h1>{slide.title}</h1>
                <p>{slide.subtitle}</p>
                <a href={slide.link} className="slide-btn">
                  {slide.button}
                </a>
              </div>
            </div>
          </div>
        ))}

        <button className="arrow prev" onClick={prev}>‹</button>
        <button className="arrow next" onClick={next}>›</button>

        <div className="dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === current ? "active" : ""}`}
              onClick={() => goTo(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      <style>{`
        .slideshow {
          position: relative;
          width: 100vw;
          height: 85vh;
          min-height: 520px;
          overflow: hidden;
          background: #000;
          margin-left: calc(-50vw + 50%);
        }

        .slide {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          opacity: 0;
          transition: opacity 1s ease-in-out;
          z-index: 1;
        }
        .slide.active {
          opacity: 1;
          z-index: 2;
        }

        .slide-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(0, 0, 0, 0.4) 60%,
            rgba(0, 0, 0, 0.15) 100%
          );
          display: flex;
          align-items: center;
          padding: 0 90px;
        }

        .slide-content {
          max-width: 700px;
          color: #fff;
          animation: fadeUp 1s ease;
        }

        .slide-content h1 {
          font-size: 52px;
          font-weight: 900;
          line-height: 1.15;
          margin: 0 0 20px;
          letter-spacing: -0.5px;
        }

        .slide-content p {
          font-size: 18px;
          line-height: 1.6;
          margin-bottom: 30px;
          color: #e5e7eb;
        }

        .slide-btn {
          display: inline-block;
          background: #c8102e;
          color: #fff;
          padding: 14px 32px;
          border-radius: 4px;
          text-decoration: none;
          font-weight: 700;
          font-size: 15px;
          letter-spacing: 1px;
          transition: background 0.2s ease;
        }
        .slide-btn:hover {
          background: #a00d24;
        }

        .arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0, 0, 0, 0.35);
          color: #fff;
          border: none;
          font-size: 42px;
          line-height: 1;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s ease;
        }
        .arrow:hover {
          background: rgba(0, 0, 0, 0.65);
        }
        .arrow.prev { left: 24px; }
        .arrow.next { right: 24px; }

        .dots {
          position: absolute;
          bottom: 28px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 12px;
          z-index: 10;
        }
        .dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 2px solid #fff;
          background: transparent;
          cursor: pointer;
          padding: 0;
          transition: background 0.2s ease;
        }
        .dot.active {
          background: #c8102e;
          border-color: #c8102e;
        }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .slideshow {
            height: 70vh;
            min-height: 420px;
          }
          .slide-overlay { padding: 0 24px; }
          .slide-content h1 { font-size: 30px; }
          .slide-content p { font-size: 15px; }
          .slide-btn { padding: 12px 24px; font-size: 14px; }
          .arrow { width: 44px; height: 44px; font-size: 32px; }
          .arrow.prev { left: 12px; }
          .arrow.next { right: 12px; }
        }
      `}</style>
    </>
  );
}

export default Slideshow;